type PageUrls = {
    lockedItemRedirect: string,
    businessGuideline: string,
};

type Config = {
    publicImageUrl: string,
    dataUrl: string,
    addFavoriteUrl: string,
    delFavoriteUrl: string,
    getFavoritesUrl: string,
    audioLessonBaseUrl: string,
    pageUrls: PageUrls,
};

const PRODUCTION_BASE = 'https://elemental-app.com';
const audioLessonBaseUrl = `${PRODUCTION_BASE}/assets/mentals/`;

const pageUrls: PageUrls = {
    lockedItemRedirect: 'https://elemental-app.com/abo-plan/',
    businessGuideline: 'https://elemental-app.com/leitfaden/',
};

const devConfig: Config = {
    publicImageUrl: process.env.PUBLIC_URL,
    dataUrl: '/api-testausgabe.json',
    addFavoriteUrl: '/api_favorites_add_success.json',
    delFavoriteUrl: '/api_favorites_del_success.json',
    getFavoritesUrl: '/api_favorites_get.json',
    audioLessonBaseUrl,
    pageUrls,
};

const productionConfig: Config = {
    publicImageUrl: `${PRODUCTION_BASE}/wp-content/plugins/elemental-webapp/build`,
    dataUrl: `${PRODUCTION_BASE}/wp-content/plugins/eleMental/eleMental-api.php?eleh=f7b7392e54595e62d288&action=get_frontendData`,
    addFavoriteUrl: `${PRODUCTION_BASE}/wp-content/plugins/eleMental/eleMental-api.php?eleh=f7b7392e54595e62d288&action=add_favorite`,
    delFavoriteUrl: `${PRODUCTION_BASE}/wp-content/plugins/eleMental/eleMental-api.php?eleh=f7b7392e54595e62d288&action=del_favorite`,
    getFavoritesUrl: `${PRODUCTION_BASE}/wp-content/plugins/eleMental/eleMental-api.php?eleh=f7b7392e54595e62d288&action=get_favorites`,
    audioLessonBaseUrl,
    pageUrls,
};

const config: Config = process.env.NODE_ENV === 'production'
    ? productionConfig
    : devConfig;

export default config;
